import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import Icon from "../../assets/check.png";

const RegisterModal = (props) => {
  const { show, handleClose, registredWebinar } = props;
  return (
    <>
      {show ? (
        <Modal
          show={show}
          onHide={handleClose}
          centered={true}
          className="register_modal"
        >
          <Modal.Body
            className="register-body"
            // style={{ width: "650px", padding: "20px 30px" }}
          >
            <div className="d-flex flex-column justify-content-center align-items-center register_modal_content">
              <img src={Icon} className="delete-icon" alt="success" />
              <p className="register_header mt-3">You’re Registered! </p>
              <p className="text-center my-0 px-3">
                Thank you for registering for our upcoming webinar{" "}
              </p>
              <p className="mt-0">
                <span className="webinar_data">
                  {registredWebinar.webinar_title}
                </span>{" "}
                on{" "}
                <span className="webinar_data">
                  {registredWebinar.webinar_start_date_time
                    ? moment(
                        registredWebinar.webinar_start_date_time.split("+")[0]
                      ).format("MMM DD, YYYY, hh:mm A")
                    : null}
                </span>
              </p>
              <div className="d-flex flex-row justify-content-center my-3">
                <button
                  className="btn primary-cta-button rounded-pill px-5 mr-2"
                  onClick={handleClose}
                >
                  Okay
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};

export default RegisterModal;
